module.exports = __webpack_public_path__ + "media/19.0113dbde.mp3";